// Stolen from https://gist.github.com/aabiskar/c1d80d139f83f6a43593ce503e29964c
import crypto from 'crypto';

const algorithm = 'aes-256-cbc';
// Must be 32 hex code characters
const encryption_key = 'byz9VFNtbRQM0yBODcCb1lrUtVVH3D3x';
// Must be 16 hex code characters
const initialization_vector = 'X05IGQ5qdBnIqAWD';

export function encryptId(id: string): string {
	// Encode the task id
	const cipher = crypto.createCipheriv(
		algorithm,
		Buffer.from(encryption_key),
		Buffer.from(initialization_vector),
	);
	let encrypted = cipher.update(id, 'utf8', 'hex');
	encrypted += cipher.final('hex');

	return encrypted;
}

export function decryptId(encryptedId: string): string {
	const decypher = crypto.createDecipheriv(
		algorithm,
		Buffer.from(encryption_key),
		Buffer.from(initialization_vector),
	);

	let decrypted = decypher.update(encryptedId, 'hex', 'utf8');
	decrypted += decypher.final('utf8');
	return decrypted;
}
